import React, { useState, useEffect } from "react";
import "./faq.css";
import AOS from "aos";
import "aos/dist/aos.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  // Toggle Question
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Initialize AOS Animation
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // ---- Fazo Academy FAQs ----
  const academyFAQs = [
    {
      q: "1. What programs does Fazo Academy offer?",
      a: "Fazo Academy offers a wide range of programs including software development, data science, digital marketing, and more. Our flagship program is the testing training course.",
    },
    {
      q: "2. Are the courses at Fazo Academy accredited?",
      a: "Yes, our courses are accredited and recognized within the industry. We maintain high standards of education and curriculum development.",
    },
    {
      q: "3. Is financial aid available for students?",
      a: "Yes, Fazo Academy offers flexible payment options and financial aid for eligible students, including scholarships and grants.",
    },
    {
      q: "4. Are there any prerequisites for enrolling in courses?",
      a: "Prerequisites vary depending on the course. Some may require prior knowledge or experience. Our counselors can guide you accordingly.",
    },
    {
      q: "5. Do you offer job placement assistance?",
      a: "Yes, Fazo Academy provides job placement assistance through career services, resume workshops, and interview training.",
    },
  ];

  // ---- Automation Testing FAQs ----
  const automationFAQs = [
    {
      q: "1. What is the Automation Testing Course at Fazo Academy?",
      a: "It’s a comprehensive program covering automation frameworks, scripting, and tools like Selenium for efficient testing.",
    },
    {
      q: "2. Who is the Automation Testing Course suitable for?",
      a: "It’s suitable for beginners and professionals looking to build or advance their career in software testing.",
    },
    {
      q: "3. What will I learn in the course?",
      a: "You’ll learn automation concepts, frameworks, tools (Selenium), scripting, and hands-on project experience.",
    },
    {
      q: "4. Are there any prerequisites?",
      a: "No strict prerequisites. Basic software testing knowledge and willingness to learn are sufficient.",
    },
    {
      q: "5. Is the course online or in-person?",
      a: "Fazo Academy offers both online and in-person options for maximum flexibility.",
    },
    {
      q: "6. How long is the course?",
      a: "Course duration varies from a few weeks to a few months depending on the schedule.",
    },
    {
      q: "7. What career opportunities can I pursue?",
      a: "Graduates can become automation testers, QA engineers, or automation developers across various industries.",
    },
    {
      q: "8. Does Fazo Academy offer placement for automation graduates?",
      a: "Yes, job placement assistance is provided through our dedicated career services team.",
    },
  ];

  // ---- Training Method FAQs ----
  const trainingFAQs = [
    {
      q: "1. What training methods does Fazo Academy use?",
      a: "We use interactive lectures, projects, peer collaboration, mentorship, and flexible learning options.",
    },
    {
      q: "2. Are the lectures interactive?",
      a: "Yes, our lectures encourage active engagement and collaboration between students and instructors.",
    },
    {
      q: "3. How are hands-on projects incorporated?",
      a: "Projects simulate real-world challenges to reinforce learning and build strong portfolios.",
    },
    {
      q: "4. Is peer collaboration encouraged?",
      a: "Yes, team collaboration helps share knowledge and improve learning outcomes.",
    },
    {
      q: "5. Do students receive one-on-one mentorship?",
      a: "Yes, personalized mentorship is part of every student’s journey at Fazo Academy.",
    },
    {
      q: "6. How is the curriculum updated?",
      a: "Our curriculum is regularly revised to reflect the latest industry technologies and best practices.",
    },
    {
      q: "7. Does Fazo Academy offer flexible learning options?",
      a: "Yes, we offer part-time, full-time, online, and in-person training modes.",
    },
    {
      q: "8. Are there opportunities for practical application?",
      a: "Absolutely. Students work on coding exercises, simulations, and real-world case studies.",
    },
  ];

  const categories = [
    { title: "FAQs about Fazo Academy", data: academyFAQs },
    { title: "FAQs about Automation Testing Course", data: automationFAQs },
    { title: "FAQs about Training Methods", data: trainingFAQs },
  ];

  return (
    <div className="faq-section-one">
      <div className="container">
        <section className="section-margin" data-aos="fade-up">
          <div className="headlines-for-all">
            <h4>
              <span>Frequently</span> Asked Questions
            </h4>
            <p>
              Find answers to the most common questions about our courses,
              learning process, certifications, and career support.
            </p>
          </div>
        </section>

        <div className="faq-container">
          {categories.map((cat, catIndex) => (
            <div
              className="faq-category"
              key={catIndex}
              // data-aos="fade-up"
              // data-aos-delay={catIndex * 200}
            >
              <h2 className="faq-title">{cat.title}</h2>

              {cat.data.map((item, index) => {
                const itemIndex = `${catIndex}-${index}`;
                const isOpen = openIndex === itemIndex;

                return (
                  <div className="faq-item" key={itemIndex}>
                    <button
                      className={`faq-question ${isOpen ? "active" : ""}`}
                      onClick={() => toggleFAQ(itemIndex)}
                      // data-aos="fade-up"
                    >
                      {item.q}
                      <span className="arrow">{isOpen ? "▲" : "▼"}</span>
                    </button>

                    <div
                      className="faq-answer"
                      style={{
                        maxHeight: isOpen ? "500px" : "0",
                        opacity: isOpen ? "1" : "0",
                        transition: "all 0.4s ease",
                      }}
                    >
                      <p>{item.a}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
